import { FC } from 'react';

/**
 * Plus버튼은 absolute로 고정되어 있고, 나머지는 flex로 배치되어 있습니다.
 * 해당 레이아웃을 유지하기 위해 spacer를 사용합니다.
 */
const FlexSpacer: FC<{ size?: number }> = ({ size = 24 }) => <div style={{ width: size }} />;

export default FlexSpacer;
